import React, { useState } from "react";
import images from "../../Constant/images";
import {
  Container,
  PopularCourseContent,
  StatusDiv,
  StudentList,
  YourCourse,
} from "./styles";
import SmartImage from "../../Components/SmartImage";
import CustomText from "../../Components/Text";
import Colors from "../../Constant/Colors";
import { FONTS, STYLES } from "../../Constant/Theme";

const StudentsPage = ({}) => {
  const [heading] = useState([
    "Name",
    "Student ID",
    "Courses",
    "Join Date",
    "Status",
  ]);
  const [students] = useState([]);
  return (
    <Container>
      <PopularCourseContent>
        <SmartImage
          src={images.studentChart1}
          style={{
            width: "18%",
            height: "100%",
          }}
        />
        <SmartImage
          src={images.studentChart2}
          style={{
            width: "18%",
            height: "100%",
          }}
        />
        <SmartImage
          src={images.studentChart3}
          style={{
            width: "30%",
            height: "100%",
          }}
        />
      </PopularCourseContent>
      <div style={{ marginTop: 10, marginBottom: 20 }}>
        <CustomText
          text={"Students"}
          style={{ ...FONTS.SemiBold20, color: Colors.primary2 }}
        />
      </div>
      <PopularCourseContent>
        {heading.map((each) => (
          <div
            style={{
              ...STYLES.HorizontalAlign,
              width: each === "Name" ? "25%" : "18%",
              justifyContent: "flex-start",
            }}
          >
            <CustomText text={each} style={{ ...FONTS.SemiBold12 }} />
            {each && (
              <SmartImage
                src={images.upDown}
                style={{ width: 10, height: 10 }}
              />
            )}
          </div>
        ))}
      </PopularCourseContent>
      <PopularCourseContent>
        {students.map((each) => (
          <StudentList key={each?.id}>
            <div
              style={{
                ...STYLES.HorizontalAlign,
                width: "25%",
                justifyContent: "flex-start",
                overflow: "hidden",
              }}
            >
              <SmartImage
                src={each?.pic}
                style={{ width: 25, height: 25, marginRight: 10 }}
              />
              <CustomText text={each?.name} style={{ ...FONTS.SemiBold12 }} />
            </div>
            <CustomText
              text={`${each?.id}`}
              style={{ ...FONTS.SemiBold12, width: "18%" }}
            />
            <CustomText
              text={`${each?.course}`}
              style={{ ...FONTS.SemiBold12, width: "18%" }}
            />
            <CustomText
              text={`${each?.joinDate}`}
              style={{ ...FONTS.SemiBold12, width: "18%" }}
            />

            <div style={{ width: "18%" }}>
              <StatusDiv status={each?.status}>
                <p>{each?.status}</p>
              </StatusDiv>
            </div>
            <SmartImage
              src={images.dots1}
              style={{ height: 15, width: 15, cursor: "pointer" }}
            />
          </StudentList>
        ))}
      </PopularCourseContent>
    </Container>
  );
};

export default StudentsPage;
